import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        container: {
            backgroundColor: palette.grey[50],
            padding: theme.spacing(4),
            border: `1px solid ${palette.border.primary}`,
            borderRadius: 1,
            width: '100%',
        },
        assignedToContainer: {
            backgroundColor: palette.background.default,
            padding: theme.spacing(2),
            border: `1px solid ${palette.border.primary}`,
            borderRadius: 1,
            display: 'flex',
            justifyContent: 'space-between',
        },
        assignedToTitleContainer: {
            marginBottom: theme.spacing(1),
        },
        header: {
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: theme.spacing(2),
        },
        taskDetailsContainer: {
            marginTop: theme.spacing(3),
        },
        taskDetail: {
            marginTop: theme.spacing(3),
            display: 'grid',
            gridTemplateColumns: '100px 1fr',
        },
    })
})

export const AssignedToStyles: moduleStyleType = {
    assignedToContainer: {
        backgroundColor: 'background.default',
        padding: 2,
        border: `1px solid ${palette.border.primary}`,
        borderRadius: 1,
        display: 'flex',
        justifyContent: 'space-between',
    },
    assignedToTitleContainer: {
        marginBottom: 1,
    },
}

export const AssignUserStyles: moduleStyleType = {
    container: {
        padding: 2,
        borderColor: 'border.subtle',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: 1,
        backgroundColor: 'background.default',
        borderLeftWidth: '6px',
        borderLeftColor: 'primary.main',
    },
    assignUserContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    noApproverDisplay: {
        flexGrow: 1,
        marginRight: 1,
    },
}

export const ActionableUserListContainerStyles: moduleStyleType = {
    container: {
        mt: 2,
        mb: 1,
    },
    userListContainer: {
        my: 1,
    },
}
